import type { ActionDashboardItem } from '@frontend/api';
import {
  VStack,
  Empty,
  EmptyHeadline,
  EmptyDescription,
  EmptyDrawerIcon,
} from '@frontend/components';

import { ReqsReviewAction } from './ReqsReviewAction';

interface ReqsReviewActionsListProps {
  items: ActionDashboardItem[];
}

export const ReqsReviewActionsList = ({
  items,
}: ReqsReviewActionsListProps) => {
  return (
    <VStack
      flex="1 1 100%"
      overflowY="auto"
      p={0}
      spacing={0}
      alignItems="stretch"
    >
      {items.length === 0 ? (
        <Empty p={2}>
          <EmptyDrawerIcon />
          <EmptyHeadline>No review items</EmptyHeadline>
          <EmptyDescription>
            You don&apos;t have any review items assigned to you.
          </EmptyDescription>
        </Empty>
      ) : (
        items.map((item) => <ReqsReviewAction key={item.uuid} item={item} />)
      )}
    </VStack>
  );
};
